export enum CalculationStatus {
  Success = 'success',
  Failure = 'failure',
  LastFailure = 'lastFailure'
}
